module.exports = __webpack_public_path__ + "burst_shape-d73e5b7aa5d1f5e70d01f1f0edd5af4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/burst_shape.png
// module id = 1539
// module chunks = 1